import { React, useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Fab from '@mui/material/Fab';
import SearchIcon from '@mui/icons-material/Search';
import LoadingIndicator from '../LoadingIndicator';
import TokenService from '../../services/TokenService'
import { useSnackbar } from 'notistack';
import cloneDeep from 'lodash/cloneDeep';
import dayjs from 'dayjs';
import Skeleton from '@mui/material/Skeleton';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import SaveIcon from '@mui/icons-material/Save';
import BusinessIcon from '@mui/icons-material/Business';
import HomeIcon from '@mui/icons-material/Home';
import Stack from '@mui/material/Stack';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import CheckIcon from '@mui/icons-material/Check';
import AddIcon from '@mui/icons-material/Add';
import CustomerNoteItem from './CustomerNoteItem';
import AddCustomerNote from '../Modals/AddCustomerNote'
import {
    Card,
    CardContent,
    Accordion,
    AccordionDetails,
    AccordionSummary,
}
    from '@mui/material/'

import OrderListTable from '../Pickups/OrderListTable.jsx';
import AdminOrderView from '../Pickups/AdminOrderView.jsx';
import Slide from '@mui/material/Slide';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

export default function CustomerItem(props) {
    var utc = require('dayjs/plugin/utc');
    dayjs.extend(utc);
    var duration = require('dayjs/plugin/duration');
    dayjs.extend(duration);
    var relativeTime = require('dayjs/plugin/relativeTime');
    dayjs.extend(relativeTime);

    const [client, setClient] = useState(props.client);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [isLoading, setIsLoading] =useState(true);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [IsEdittingAccount, setIsEdittingAccount] =useState(false);
    const [formValidation, setFormValidation] =useState({
        isValid: false,
        errors: []
    });

    // for editting fields:
    const [customerEmail, setcustomerEmail] =useState('');
    const [customerName, setcustomerName] =useState('');
    const [customerLastname, setcustomerLastname] =useState('');
    const [customerPhoneNum, setcustomerPhoneNum] =useState('');
    const [customerAddress_Street, setcustomerAddress_Street] =useState('');
    const [customerAddress_Apt_Suit_Other, setcustomerAddress_Apt_Suit_Other] =useState('');
    const [customerAddress_City, setcustomerAddress_City] =useState('');
    const [customerAddress_State, setcustomerAddress_State] =useState('');
    const [customerAddress_Zipcode, setcustomerAddress_Zipcode] =useState('');
    const [latitude, setlatitude] =useState('');
    const [longitude, setlongitude] =useState('');
    const [payeeName, setpayeeName] =useState('');
    const [memo, setmemo] =useState('');
   // const [clientBanned, setClientBanned] = useState({});

    const [addCustomerNoteDialog, setAddCustomerNoteDialog] = useState(null);

    function buildSkeleton() {
        return <div>
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
        </div>
    }

    function normalizePhoneNumber(value, previousValue) {
        if (!value) return value;
        const currentValue = value.replace(/[^\d]/g, '');
        const cvLength = currentValue.length;

        //if (!previousValue)// || value.length > previousValue.length)
        {
            if (cvLength < 4) return currentValue;
            if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
            return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
        }
    };

    function setPhoneNumberChanged(val) {
        let phone = normalizePhoneNumber(val);
        let temp = cloneDeep(client);
        temp.CustomerPhoneNum = phone;
        setClient(temp);
    }

    function toggleIsEdittingAccount(editting) {
        if (editting) {
            setcustomerEmail(client.CustomerEmail);
            setcustomerName(client.CustomerName);
            setcustomerLastname(client.CustomerLastname);
            setcustomerPhoneNum(normalizePhoneNumber(client.CustomerPhoneNum));
            setcustomerAddress_Street(client.CustomerAddress_Street);
            setcustomerAddress_Apt_Suit_Other(client.CustomerAddress_Apt_Suit_Other);
            setcustomerAddress_City(client.CustomerAddress_City);
            setcustomerAddress_State(client.CustomerAddress_State);
            setcustomerAddress_Zipcode(client.CustomerAddress_Zipcode);
           // setClientBanned(client.ClientBanned);
            setFormValidation({
                isValid: true,
                errors: []
            });

        }
        setIsEdittingAccount(editting);
    }

    function handleSaveClient() {
        let isValid = true;

        let errors = [];

        if (customerName.trim() == '') {
            isValid = false;
            errors["customerName"] = "First name is required";
        }

        if (customerLastname.trim() == '') {
            isValid = false;
            errors["customerLastname"] = "Last name is required";
        }

        if (customerPhoneNum.trim() == '') {
            isValid = false;
            errors["customerPhoneNum"] = "Phone Number is required";
        }

        if (customerAddress_Street.trim() == '') {
            isValid = false;
            errors["customerAddress_Street"] = "Street is required";
        }

        if (customerAddress_City.trim() == '') {
            isValid = false;
            errors["customerAddress_City"] = "City is required";
        }

        if (customerAddress_Zipcode.trim() == '') {
            isValid = false;
            errors["customerAddress_Zipcode"] = "Zip is required";
        }

        setFormValidation({
            isValid: isValid,
            errors: errors
        });

        if (isValid) {
            setIsLoading(true);

            let postData = {
                client: JSON.stringify({
                    ClientId: props.client.ClientId,
                    CustomerName: customerName,
                    CustomerLastname: customerLastname,
                    CustomerPhoneNum: customerPhoneNum,
                    CustomerAddress_Street: customerAddress_Street,
                    CustomerAddress_Apt_Suit_Other: customerAddress_Apt_Suit_Other,
                    CustomerAddress_City: customerAddress_City,
                    CustomerAddress_Zipcode: customerAddress_Zipcode
                })
            }

            TokenService.post(postData, 'Admin_UpdateClient_v2')
                .then((response) => {
                    response = response[Object.keys(response)[0]];
                    if (response.Result == "SUCCESS") {
                        let jsonData = JSON.parse(response.JsonData);

                        setClient(jsonData);

                        setIsLoading(false);
                        setIsEdittingAccount(false);

                        if (props.onUpdated != undefined) {
                            props.onUpdated(jsonData);
                        }
                    }
                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                });
        }
    }

    function handleOrderSelected(order) {
        setSelectedOrder(order);
    }

    function handleOrderUpdated(updatedOrder) {
        let temp = cloneDeep(client);
        let isFound = false;
        for (let i = 0; i < client.OpenRequests.length; i++) {
            if (updatedOrder.RequestID == client.OpenRequests[i].RequestID) {
                client.OpenRequests[i] = updatedOrder;
                isFound = true;
                break;
            }
        }
        if (!isFound) {
            for (let i = 0; i < client.ClosedRequests.length; i++) {
                if (updatedOrder.RequestID == client.ClosedRequests[i].RequestID) {
                    client.ClosedRequests[i] = updatedOrder;
                    isFound = true;
                    break;
                }
            }
        }
        setClient(temp);

        if (props.onUpdated != undefined) {
            props.onUpdated(temp);
        }
    }

    function showSelectedOrderDialog() {
        return <Dialog
            open={true}
            onClose={() => setSelectedOrder(null)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            style={{ marginLeft: '10px' }}

        >
            <DialogContent style={{ height: '90vh', paddingLeft: '5px' }}>
                <AdminOrderView
                    orderUpdated={handleOrderUpdated}
                    order={selectedOrder}
                    onBack={() => setSelectedOrder(null)}
                    loggedInUser={props.loggedInUser}
                />
            </DialogContent>
        </Dialog>
       
    }

    function handleClientBanChange(e) {
        let temp = cloneDeep(props.client);
        let postData = {
            customerEmail: client.CustomerEmail,
            banType: ''
        };

        if (e.target.value == 'Hard') {
            temp.ClientBanned = { BanType: 'Hard' }
            postData.banType= 'Hard';
        }
        else if (e.target.value == 'Soft') {
            temp.ClientBanned = { BanType: 'Soft' }
            postData.banType = 'Soft';
        }
        else {
            temp.ClientBanned = {}
        }

       

       

        

        TokenService.adminServicePost(postData, 'Admin_UpdateCustomerBan')
            .then((response) => {
                if (response.Result == "SUCCESS") {
                    setClient(temp);
                    if (props.onUpdated != undefined) {
                        props.onUpdated(temp);
                    }
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function showOrders(orders, section) {
        return <OrderListTable Orders={orders} loggedInUser={props.loggedInUser} Section='Admin' OrderSelected={handleOrderSelected} SectionDetail={section} />
    }

    function handleShowAddCustomerNote(noteType) {
        setAddCustomerNoteDialog(<AddCustomerNote noteType={noteType} clientId={props.client.ClientId} close={(didAccept, note) => handleAddCustomerNoteClosed(didAccept, note)} />)
    }

    function handleAddCustomerNoteClosed(didAccept, note) {
        if (didAccept) {
            // add it to the Client object
            let temp = cloneDeep(props.client);
            temp.ClientNotes.push(note);
            setClient(temp);
            props.onUpdated(temp);
        }
        setAddCustomerNoteDialog(null);
    }

    function handleDeleteCustomerNote(note) {

        let temp = cloneDeep(props.client);
        for (let i = 0; i < temp.ClientNotes.length; i++) {
            if (temp.ClientNotes[i].ClientNoteId == note.ClientNoteId) {
                temp.ClientNotes.splice(i, 1);
                break;
            }
        }
        setClient(temp);
        props.onUpdated(temp);


    }

    return (
        <div componentname='CustomerItem' style={{ backgroundColor: "#efefef", padding: '5px', flexWrap: 'wrap' }}>
            <div style={{display:'flex', justifyContent:'flex-start', flexWrap:'wrap'} }>
                <Card style={{ minWidth: '330px', margin: '2px' } }>
                    <CardContent>
                        <Stack spacing={1}>
                            <div style={{ display: 'flex', justifyContent: 'flex-start', fontWeight: 'bold', fontSize: '14pt', color: 'var(--sipzee-yellow)' }}>Contact Info</div>
                            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                <AccountCircleIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30, marginTop: '5px' }} />
                                {IsEdittingAccount ?
                                    <div style={{ marginLeft: '10px' }}>
                                        <div>
                                            <TextField error={formValidation.errors['customerName'] !== undefined} label="First Name" onChange={(e) => setcustomerName(e.target.value)} value={customerName} variant="outlined" style={{ maxWidth: '270px' }} />
                                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['customerName'] !== undefined ? formValidation.errors['customerName'] : ''}</div>
                                        </div>
                                        <div style={{ marginTop: '7px' }}>
                                            <TextField error={formValidation.errors['customerLastname'] !== undefined} label="Last Name" onChange={(e) => setcustomerLastname(e.target.value)} value={customerLastname} variant="outlined" style={{ maxWidth: '270px' }} />
                                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['customerLastname'] !== undefined ? formValidation.errors['customerLastname'] : ''}</div>
                                        </div>
                                    </div>
                                    :
                                    <div style={{ marginRight: 'auto', marginLeft: 'auto', fontWeight: 'bold', fontSize: '14pt', alignSelf: 'center' }}>{client.CustomerName} {client.CustomerLastname}</div>
                                }
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                <PhoneIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30, alignSelf: 'center' }} />

                                {IsEdittingAccount ?
                                    <div style={{ marginLeft: '10px' }}>
                                        <div style={{ marginTop: '7px' }}>
                                            <TextField error={formValidation.errors['customerPhoneNum'] !== undefined} label="Phone Number" onChange={(e) => setPhoneNumberChanged(e.target.value)} value={customerPhoneNum} variant="outlined" inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} style={{ maxWidth: '270px' }} />
                                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['customerPhoneNum'] !== undefined ? formValidation.errors['customerPhoneNum'] : ''}</div>
                                        </div>
                                    </div>
                                    :
                                    <div style={{ marginRight: 'auto', marginLeft: 'auto', alignSelf: 'center' }}>{client.CustomerPhoneNum}</div>

                                }
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                <EmailIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30, alignSelf: 'center' }} />
                                <div style={{ marginRight: 'auto', marginLeft: 'auto', alignSelf: 'center' }}>{client.CustomerEmail}</div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                {client.LocationType == 'Residence' ?
                                    <HomeIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30, marginTop: '5px' }} />
                                    :
                                    <BusinessIcon sx={{ color: 'var(--sipzee-green)', fontSize: 30, marginTop: '5px' }} />
                                }

                                {IsEdittingAccount ?
                                    <div style={{ marginLeft: '10px' }}>
                                        <div>
                                            <TextField error={formValidation.errors['customerAddress_Street'] !== undefined} label="Street" onChange={(e) => setcustomerAddress_Street(e.target.value)} value={customerAddress_Street} variant="outlined" style={{ maxWidth: '270px' }} />
                                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['customerAddress_Street'] !== undefined ? formValidation.errors['customerAddress_Street'] : ''}</div>
                                        </div>
                                        <div style={{ marginTop: '7px' }}>
                                            <TextField error={formValidation.errors['customerAddress_Apt_Suit_Other'] !== undefined} label="Apt/Suite" onChange={(e) => setcustomerAddress_Apt_Suit_Other(e.target.value)} value={customerAddress_Apt_Suit_Other} variant="outlined" style={{ maxWidth: '270px' }} />
                                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['customerAddress_Apt_Suit_Other'] !== undefined ? formValidation.errors['customerAddress_Apt_Suit_Other'] : ''}</div>
                                        </div>
                                        <div style={{ marginTop: '7px' }}>
                                            <TextField error={formValidation.errors['customerAddress_City'] !== undefined} label="City" onChange={(e) => setcustomerAddress_City(e.target.value)} value={customerAddress_City} variant="outlined" style={{ maxWidth: '270px' }} />
                                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['customerAddress_City'] !== undefined ? formValidation.errors['customerAddress_City'] : ''}</div>
                                        </div>
                                        <div style={{ marginTop: '7px' }}>
                                            <TextField error={formValidation.errors['customerAddress_State'] !== undefined} disabled={true} label="State" value={customerAddress_State} variant="outlined" style={{ maxWidth: '270px' }} />
                                        </div>
                                        <div style={{ marginTop: '7px' }}>
                                            <TextField error={formValidation.errors['customerAddress_Zipcode'] !== undefined} label="Zip" onChange={(e) => handleZipcodeChanged(e)} value={customerAddress_Zipcode} variant="outlined" style={{ maxWidth: '270px' }} inputProps={{ maxLength: 5, inputMode: 'numeric', pattern: '[0-9]*' }} />
                                            <div className='FormFieldErrorDescription' style={{ textAlign: 'left' }}> {formValidation.errors['customerAddress_Zipcode'] !== undefined ? formValidation.errors['customerAddress_Zipcode'] : ''}</div>
                                        </div>
                                    </div>
                                    :
                                    <div style={{ marginRight: 'auto', marginLeft: 'auto', alignSelf: 'center' }}>
                                        <div style={{ marginRight: 'auto', marginLeft: 'auto', alignSelf: 'center' }}>{client.CustomerAddress_Street} {client.CustomerAddress_Apt_Suit_Other}</div>
                                        <div style={{ marginRight: 'auto', marginLeft: 'auto', alignSelf: 'center' }}>{client.CustomerAddress_City}, {client.CustomerAddress_State} {client.CustomerAddress_Zipcode}</div>
                                    </div>
                                }
                            </div>

                            <div>

                                {IsEdittingAccount ?
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }} >
                                        <Fab onClick={() => toggleIsEdittingAccount(false)}>
                                            <DoDisturbIcon sx={{ color: 'var(--sipzee-red)', fontSize: 30 }} />
                                        </Fab>
                                        <Fab onClick={handleSaveClient}>
                                            <SaveIcon sx={{ color: 'var(--sipzee-gray)', fontSize: 30 }} ></SaveIcon>
                                        </Fab>
                                    </div>
                                    :
                                    <Fab onClick={() => toggleIsEdittingAccount(true)}>
                                        <EditIcon sx={{ color: 'var(--sipzee-gray)', fontSize: 30 }} />
                                    </Fab>
                                }


                            </div>

                        </Stack>
                    </CardContent>
                </Card>

                <Card style={{ minWidth: '330px', margin:'2px' }}>
                    <CardContent>
                        <Stack spacing={1}>
                            <div style={{ display: 'flex', justifyContent: 'flex-start', fontWeight: 'bold', fontSize: '14pt', color: 'var(--sipzee-yellow)' }}>Status</div>
                            <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                               
                                <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                   
                                    name="radio-buttons-group"
                                >

                                    <FormControlLabel value={null} control={<Radio checked={client.ClientBanned.BanType == null} onChange={(e) => handleClientBanChange(e)} />} label={<div style={{ display: 'flex' }}><CheckIcon sx={{ color: 'var(--sipzee-green)' }} /> <div style={{ alignSelf: 'center' }}>Active</div></div>} />
                                    <div style={{ marginBottom: '10px' }}></div>
                                    <FormControlLabel value="Soft" control={<Radio checked={client.ClientBanned.BanType == 'Soft'} onChange={(e) => handleClientBanChange(e)} />} label={<div style={{ display: 'flex' }}><RemoveCircleOutlineIcon checked={true} sx={{ color: 'var(--sipzee-yellow)' }} /> <div style={{ alignSelf: 'center' }}>Soft Ban</div></div>} />
                                    <div style={{ fontStyle: 'italic', marginBottom: '10px' } }>Customer orders are not visible to recyclers.</div>
                                    <FormControlLabel value="Hard" control={<Radio checked={client.ClientBanned.BanType == 'Hard'} onChange={(e) => handleClientBanChange(e)} />} label={<div style={{ display: 'flex' }}><RemoveCircleIcon sx={{ color: 'var(--sipzee-red)' }} /> <div style={{ alignSelf: 'center' }}>Hard Ban</div></div>} />
                                    <div style={{ fontStyle: 'italic' }}>Customer order submission shows No Service prompt</div>
                                </RadioGroup>
                            </div>

                          
                        </Stack>
                    </CardContent>
                </Card>
                <Card style={{ minWidth: '330px', margin: '2px' }}>
                    <CardContent>
                        <Stack spacing={1}>
                            <div style={{ display: 'flex', justifyContent: 'flex-start', fontWeight: 'bold', fontSize: '14pt', color: 'var(--sipzee-yellow)' }}>
                                <div style={{alignSelf:'center'} }>Internal Notes</div>
                                <Fab onClick={(e) => handleShowAddCustomerNote('Internal')} style={{ marginLeft: 'auto' }} size={'small'}><AddIcon  /></Fab>
                            </div>
                            {client.ClientNotes.map((note, idx) => {
                                if (note.NoteType == 'Internal') {
                                    return <CustomerNoteItem clientNote={note} onDeleted={(note) => handleDeleteCustomerNote(note)} />
                                }
                            }) }
                           
                        </Stack>
                    </CardContent>

                    
                </Card>
                <Card style={{ minWidth: '330px', margin: '2px' }}>
                    <CardContent>
                        <Stack spacing={1}>
                            <div style={{ display: 'flex', justifyContent: 'flex-start', fontWeight: 'bold', fontSize: '14pt', color: 'var(--sipzee-yellow)' }}>
                                <div style={{ alignSelf: 'center' }}>Customer Facing Notes</div>
                                <Fab onClick={(e) => handleShowAddCustomerNote('Customer')} style={{ marginLeft: 'auto' }} size={'small'}><AddIcon /></Fab>
                            </div>
                            {client.ClientNotes.map((note, idx) => {
                                if (note.NoteType == 'Customer') {
                                    return <CustomerNoteItem clientNote={note} onDeleted={(note) => handleDeleteCustomerNote(note)} />
                                }
                            })}
                        </Stack>
                    </CardContent>
                </Card>
            </div>

            {client.OpenRequests.length == 0 ? null :
                <Card style={{ marginTop: '10px' }} elevation={5}>
                    <CardContent>
                        <div style={{ display: 'flex', justifyContent: 'flex-start', fontWeight: 'bold', fontSize: '14pt', color: 'var(--sipzee-yellow)' }}>Open Orders</div>
                        {showOrders(client.OpenRequests, 'Open')}
                    </CardContent>
                </Card>    
            }

            {client.ClosedRequests.length == 0 ? null :
                <Card style={{ marginTop: '10px' }} elevation={5}>
                    <CardContent>
                        <div style={{ display: 'flex', justifyContent: 'flex-start', fontWeight: 'bold', fontSize: '14pt', color: 'var(--sipzee-yellow)' }}>Closed Orders</div>
                        {showOrders(client.ClosedRequests, 'Closed')}
                    </CardContent>
                </Card>
            }

            {selectedOrder == null ? null : 
                showSelectedOrderDialog()
            }

            {addCustomerNoteDialog }
           
        </div>
    )
} 